export class ActionEffect {

    constructor(public toast?: string) {
    }
}
